import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { applicationListService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type useCloneMpaMutationProps = {
	onSuccess?: (result) => void;
	onError?: (error: ErrorResponse) => void;
};

type UseMutationProps = {
	appId: string;
};

const useCloneMpaMutation = ({
	onSuccess,
	onError,
}: useCloneMpaMutationProps = {}) => {
	const dispatch = useDispatch();

	return useMutation(
		({ appId }: UseMutationProps) => applicationListService.cloneMpa(appId),
		{
			onSuccess: result => {
				onSuccess?.(result);
			},
			onError: (error: ErrorResponse) => {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
				onError?.(error);
			},
		},
	);
};

export default useCloneMpaMutation;
